import React from 'react';
import './App.css'; 

const HomeAr = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.png" alt="Logo"/>
        <p className="centered-paragraph">
    تصفح الإنترنت على ساعتك الذكية! وصول سريع إلى المفضلات. حسّن تجربة التصفح الآن مع تصفح الإنترنت السريع، البحث الذكي، والاتصال السلس لساعة يدك. استمتع بتجربة تصفح سلسة وفعالة مباشرة من معصمك!
</p>

        <a href='https://apps.apple.com/app/surfify-web-browser-on-watch/id6478813759?ppid=121505f9-a6b7-4285-b495-15bdd2bac71d'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
        </div>
        </>
     );
}
 
export default HomeAr;